import { Box, Container, Icon, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { GuardedRoute } from 'react-router-guards';

import { RequireRole } from 'app/components/require-role';
import { Role } from 'app/constants/role';
import { DescriptorForm } from 'features/crowd/descriptor/descriptor-form';
import { DescriptorList } from 'features/crowd/descriptor/descriptor-list';

export const CrowdSliceRouter: React.FunctionComponent = () => (
    <Container maxWidth={false} className='py-3 remaining-height'>
        <Box display='flex' sx={{ height: '100%' }}>
            <Box className='p-2'>
                <List>
                    <ListItemButton activeClassName='Mui-selected' component={NavLink} to='/crowd' exact>
                        <ListItemIcon>
                            <Icon>fact_check</Icon>
                        </ListItemIcon>
                        <ListItemText primary='Submit Descriptor' />
                    </ListItemButton>
                    <RequireRole roles={Role.SEAM_MANAGER}>
                        <ListItemButton activeClassName='Mui-selected' component={NavLink} to='/crowd/list'>
                            <ListItemIcon>
                                <Icon>list</Icon>
                            </ListItemIcon>
                            <ListItemText primary='Descriptor List' />
                        </ListItemButton>
                    </RequireRole>
                </List>
            </Box>
            <Box flexGrow={1} className='p-2'>
                <Switch>
                    <Route exact path='/crowd'>
                        <DescriptorForm />
                    </Route>
                    <GuardedRoute exact path='/crowd/list' meta={{ role: Role.SEAM_MANAGER }}>
                        <DescriptorList />
                    </GuardedRoute>
                </Switch>
            </Box>
        </Box>
    </Container>
);
